/*
 * @Author: cc
 * @LastEditTime: 2023-01-30 16:55:31
 */
/*
 * @Author: cc
 * @LastEditTime: 2021-04-06 16:11:49
 */
import { useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import axios from "@/axios/axios";

import { store } from "@/store";
export const HistoryPush = () => {
  let history = useHistory();
  return history;
};
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
export function getCookie(name: string) {
  var prefix = name + "=";
  var start = document.cookie.indexOf(prefix);

  if (start === -1) {
    return null;
  }

  var end = document.cookie.indexOf(";", start + prefix.length);
  if (end === -1) {
    end = document.cookie.length;
  }

  var value = document.cookie.substring(start + prefix.length, end);
  return unescape(value);
}
export const watch = () => {
  const data = store.getState();
  const { videoStatus } = data;
  const { courseId, sectionId, projectId } = videoStatus;
  const videoDuration = parseInt(window.ccPlayerStatus.getDuration());
  const watchAt = parseInt(window.ccPlayerStatus.getPosition());
  if (!window.ccPlayerStatus.getDuration()) return;
  if (window.ccPlayerStatus.getPosition() === 0) return;
  let time = window.ccPlayerStatus.getDuration();
  let video = window.ccPlayerStatus;
  let position = window.ccPlayerStatus.getPosition();
  axios.post(`/shop/continuing/watch/record`, {
    courseId,
    sectionId,
    videoDuration,
    watchAt,
  });
};
class videoPause {
  private count = 2;
  start(video: any, position: any, time: any) {
    console.log("开始:", window.pauseTimer, this.count);
    if (window.pauseTimer === null && this.count > 0) {
      // 随机数
      let restTime = time - parseInt(position);
      let randonNum = Math.floor(Math.random() * (restTime - 0) + 0);
      window.pauseTimer = setInterval(() => {
        if (randonNum <= 0) {
          video.pause();
          this.pause();
          this.count--;
          setTimeout(() => {
            alert("签到");
          }, 1800);
        } else {
          randonNum--;
        }
      }, 1000);
    }
  }
  pause() {
    console.log("-----清空计时器-----");
    clearInterval(window.pauseTimer);
    window.pauseTimer = null;
  }
  reset() {
    this.count = 2;
    window.pauseTimer = null;
    clearInterval(window.pauseTimer);
  }
}
export let ranDomNum = new videoPause();
